import classes from './AnnuallyForm.module.scss';
import { Calendar, CalendarProps } from 'primereact/calendar';
import { useTranslation } from 'react-i18next';
import { defaultCronObject, Props } from '../CrontabView';
import { useEffect } from 'react';


const dateToCronMonth = (date: Date): number => {
  //In JS getMonth() : [0-11] but crontab month are [1-12]
  return date.getMonth() + 1;
};

const AnnuallyForm = ({ onCronChanged, date }: Props) => {
  const { t: translate } = useTranslation();

  useEffect(() => {
    onCronChanged({
      ...defaultCronObject,
      minutes: date.getMinutes().toString(),
      hours: date.getHours().toString(),
      dayMonth: date.getDate().toString(),
      month: dateToCronMonth(date).toString()
    });
  }, []);

  const onDayChangedHandler = (val: CalendarProps) => {
    const tmp = val.value as Date;
    onCronChanged({
      ...defaultCronObject,
      dayMonth: tmp.getDate().toString(),
      month: dateToCronMonth(tmp).toString(),
      hours: date.getHours().toString(),
      minutes: date.getMinutes().toString(),
    });
  };

  const onHourChangedHandler = (val: CalendarProps) => {
    const tmp = val.value as Date;
    onCronChanged({
      ...defaultCronObject,
      dayMonth: date.getDate().toString(),
      month: dateToCronMonth(date).toString(),
      hours: tmp.getHours().toString(),
      minutes: tmp.getMinutes().toString(),
    });
  };

  const lang = navigator.language.split('-')[0];
  return (
    <>
      <div className={ classes['form-control'] }>
        <label>{ translate('cron-tab.input.on') }</label>
        <Calendar
          locale={ lang }
          showIcon
          dateFormat="dd MM"
          value={ date }
          onChange={ onDayChangedHandler }
        />
      </div>
      <div className={ classes['form-control'] }>
        <label>{ translate('cron-tab.input.at') }</label>
        <Calendar
          showIcon
          showTime
          icon="pi pi-clock"
          timeOnly
          hourFormat="24"
          value={ date }
          onChange={ onHourChangedHandler }
        />
      </div>
    </>
  );
};

export default AnnuallyForm;